export const filteringField = (arr) => {
  const hasAvi = arr.includes("avi");
  const hasLocation = arr.includes("location");
  const hasReview = arr.includes("review");

  let newArr = [...arr];

  if (hasAvi) {
    newArr = arr.filter((item) => item !== "avi");
    if (!hasReview) {
      newArr.push("review");
    }
  }
  if (hasLocation) {
    const index = newArr.indexOf("location");
    if (index !== -1) {
      newArr.splice(index, 1, "x", "y");
    }
  }
  return newArr;
};
